
export class SaveEmailModel {
    BeneficiaryEmail: string;
    RefGUID: string;
}
